const data = [
  { id: 'Sentença transitada em julgado', name: 'Sentença transitada em julgado' },
  { id: 'Acordo judicial homologado', name: 'Acordo judicial homologado' },
  { id: 'Decisão homologatória de cálculos', name: 'Decisão homologatória de cálculos' },
  { id: 'Honorários advocatícios', name: 'Honorários advocatícios' },
  { id: 'Honorários periciais', name: 'Honorários periciais' },
  { id: 'Outro', name: 'Outro' },
]

export default [...data]
